export default "__VITE_ASSET__0603127f__"